<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户列表'}]"/>
    <div class="bg-purple xzpadd10">
      <data-table
        :tableData="customerListData"
        :columns="customerListColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters.sync="filters"
      ></data-table>
    </div>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import Status2CN from "../../../filters/Status2CN";
  import {formatMoney} from "../../../filters/CommonFilters";
  import NavBreadcrumb from "../../../components/NavBreadcrumb";

  export default {
    name: 'CustomerList',
    data() {
      return {
        page: 1,
        pageSize: 10,
        customerListData: {},
        customerListColumns: [
          {
            name: '客户编号',
            field: 'c__customerCode'
          },
          {
            name: '客户姓名',
            field: 'c__customerName'
          },
          {
            name: '手机号',
            field: 'i__contactTelNo'
          },
          {
            name: '身份证号码',
            field: 'i__socialIdentityCode'
          },
          // {
          //   name: '所属行业',
          //   field: 'i__industry'
          // },
          // {
          //   name: '法人代表',
          //   field: 'i__bizrep'
          // },
          {
            name: '建档时间',
            field: 'c__createdDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD hh:mm')
            }
          },
          {
            name: '授信额度(元)',
            field: 'cr__lineOfCredit',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '状态',
            field: 'c__customerStatus',
            formatter: function (r,c,v) {
              return Status2CN('CustomerStatus_'+v)
            }
          },
          {
            name: '操作',
            opts:[
              {
                class: 'el-icon-info',
                name: '查看详情',
                clickHandler: (index, row)=>{
                  this.viewDetail(index, row)
                }
              },
              {
                class: 'el-icon-download',
                name: '导出客户资料',
                clickHandler: (index, row)=>{
                  this.exportPdf(index, row)
                }
              }
            ]
          }
        ],
        filters: {
          form: {
            c__customerId: '',
            c__customerName: '',
            i__socialIdentityCode: '',
            c__createdDate: [],
            i__bizrep: ''
          },
          columns: [
            {
              label: '客户编号',
              component: 'el-input',
              field: 'c__customerCode'
            },
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'c__customerName'
            },
            {
              label: '手机号',
              component: 'el-input',
              field: 'i__contactTelNo'
            },
            {
              label: '建档时间',
              component: 'date-range-picker',
              field: 'c__createdDate',
              op:['gteq','lteq']
            },
            {
              label: '身份证号码',
              component: 'el-input',
              field: 'i__socialIdentityCode'
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerList()
          }
        }
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'c.createdDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerList()
      }
    },
    mounted() {
      this.getCustomerList()
    },
    components: {
      NavBreadcrumb
    },
    methods: {
      getCustomerList: function () {
        xhr.getCustomerList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
          try {
            this.customerListData = res.data
          }catch(e){

          }
        })

      },
      viewDetail: function (index, row) {
        try {
          this.$router.push({
            path: 'CustomerDetail?c.customerId='+row.c__customerId+'&ac.applicationId='+row.ac__applicationId+'&cr.creditId='+row.cr__creditId+'&m.applicationId='+row.m__applicationId
          })
        }
        catch (e) {

        }
      },
      exportPdf: function (index, row) {
        try {
          window.open('/report/CustomerCredit/CustomerInfo.jasper?customerId='+row.c__customerId)
        }
        catch (e) {

        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerList.vue